<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/products'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>
<script>
import { formatNumber } from "devextreme/localization";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { FeatureStorage } from "@/_services/storage";

const PALLET_SIZES = ["Standard", "Quarter", "Half"];

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        PalletTypeCode: "",
        Description: "",
        PalletScheme: null,
        PalletSize: null,
        TareWeight: null,
        FootprintLength: null,
        FootprintWidth: null,
        PalletHeight: null,
        MaxStackHeight: null,
        MaxLoadWeight: null,
        Stackable: "N",
        StackableBool: false,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Pallet Type",
        pageRoute: "/pallet-type",
        saveEndPoint: "Save_PalletType",
        // updateEndPoint: "Save_PalletType",
        recordEndPoint: "PalletType",
        exportFileName: "Pallet Type",
        recordPostProcess: this.recordPostProcess,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "PalletType",
              filter: "",
              // select: [
              //   "PalletTypeCode",
              //   "Description",
              //   "PalletScheme",
              //   "PalletSize",
              //   "Inactive",
              //   "RecordId",
              // ],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "pallet-type",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/pallet-type/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("PalletType", "create"),
              },
            ],
          },
          columns: [
            {
              dataField: "Description",
              cellTemplate: "Record",
              sortIndex: 0,
              sortOrder: "asc",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "PalletTypeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "PalletTypeCode",
                  label: "Pallet Type Code",
                },
                {
                  dataField: "Description",
                  label: "Pallet Type Description",
                },
              ],
              allowSearch: false,
              allowHiding: false,
              label: "Pallet Type",
            },
            {
              screenField: "PalletScheme",
              dataField: "PalletScheme",
              label: "Pallet Scheme/Provider",
              width: 150,
              filterIndex: 1,
            },
            {
              dataField: "PalletSize",
              label: "Pallet Size",
              width: 120,
            },
            {
              dataField: "FootprintLength",
              label: "Footprint L x W (mm)",
              calculateCellValue: (rowData) => {
                return `${this.getFormattedQty(
                  rowData.FootprintLength,
                  "##,###,###,###,##0",
                )} x ${this.getFormattedQty(
                  rowData.FootprintWidth,
                  "##,###,###,###,##0",
                )}`;
              },
              width: 125,
            },
            {
              dataField: "PalletHeight",
              label: "Pallet Height (mm)",
              format: "##,###,###,###,##0",
              width: 125,
              alignment: "right",
            },
            {
              dataField: "MaxStackHeight",
              label: "Max Stack Height (mm)",
              format: "##,###,###,###,##0",
              width: 140,
            },
            {
              dataField: "TareWeight",
              label: "Tare Weight (kg)",
              format: "##,###,###,###,##0",
              width: 130,
            },
            {
              dataField: "MaxLoadWeight",
              label: "Max Load Weight (kg)",
              format: "##,###,###,###,##0",
              width: 130,
            },
            {
              screenField: "AvailableForSale",
              dataField: "Stackable",
              label: "Stackable",
              filterLabel: "Stackable",
              filterDataField: "Stackable",
              calculateCellValue: (rowData) => {
                return rowData.Stackable == "Y" ? "Yes" : "No";
              },
              width: 100,
              filterIndex: 2,
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 3,
            },
          ],
          valueChangedEventListners: [],
        },
      },
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission("PalletType", "create"),
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "PalletTypeCode",
                editorType: "dxTextBox",
                editorOptions: {
                  maxLength: 20,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create",
              },
              {
                dataField: "Description",
                editorType: "dxTextBox",
                editorOptions: {
                  maxLength: 255,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
              },
              {
                screenField: "PalletScheme",
                dataField: "PalletScheme",
                editorType: "dxSelectBox",
                required: true,
                label: { text: "Pallet Scheme/Provider" },
                editorOptions: {
                  searchEnabled: true,
                  showClearButton: true,
                },
              },
              {
                dataField: "PalletSize",
                editorType: "dxSelectBox",
                required: true,
                label: { text: "Pallet Size" },
                editorOptions: {
                  items: PALLET_SIZES,
                  searchEnabled: true,
                  showClearButton: true,
                },
              },
              {
                dataField: "TareWeight",
                editorType: "dxNumberBox",
                required: true,
                label: { text: "Tare Weight (kg)" },
                editorOptions: {},
                validationRules: [
                  {
                    type: "range",
                    message: "Tare Weight must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "FootprintLength",
                editorType: "dxNumberBox",
                label: { text: "Footprint Length (mm)" },
                editorOptions: {},
                validationRules: [
                  {
                    type: "range",
                    message:
                      "Footprint Length must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "FootprintWidth",
                editorType: "dxNumberBox",
                label: { text: "Footprint Width (mm)" },
                editorOptions: {},
                validationRules: [
                  {
                    type: "range",
                    message:
                      "Footprint Width must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "PalletHeight",
                editorType: "dxNumberBox",
                label: { text: "Pallet Height (mm)" },
                editorOptions: {},
                validationRules: [
                  {
                    type: "range",
                    message: "Pallet Height must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "MaxStackHeight",
                editorType: "dxNumberBox",
                label: { text: "Max Stack Height (mm)" },
                editorOptions: {},
                validationRules: [
                  {
                    type: "range",
                    message:
                      "Max Stack Height must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "MaxLoadWeight",
                editorType: "dxNumberBox",
                label: { text: "Max Load Weight (kg)" },
                editorOptions: {},
                validationRules: [
                  {
                    type: "range",
                    message:
                      "Max Load Weight must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "StackableBool",
                editorType: "dxCheckBox",
                label: { text: "Stackable" },
                editorOptions: {},
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
  },
  methods: {
    getFormattedQty(value, format = "##,###,###,###,##0.00") {
      return formatNumber(value, format);
    },
    recordPostProcess(data) {
      data["StackableBool"] = data["Stackable"] == "Y" ? true : false;
      return data;
    },
    overWritePayload(payload) {
      payload.Stackable = payload.StackableBool ? "Y" : "N";
      payload.TareWeight = payload.TareWeight || 0;
      payload.FootprintLength = payload.FootprintLength || 0;
      payload.FootprintWidth = payload.FootprintWidth || 0;
      payload.PalletHeight = payload.PalletHeight || 0;
      payload.MaxStackHeight = payload.MaxStackHeight || 0;
      payload.MaxLoadWeight = payload.MaxLoadWeight || 0;
      return payload;
    },
  },
};
</script>
